<template>
  <div class="viewTable">
    <!-- 搜索 -->
    <div v-if="showSearch" id="searchBox">
      <slot name="adSearch"/>
      <div class="moreSearch">
        <span v-if="searchs.length > 4">
          <a v-if="!searchShow" class="actionDown" @click="toggleMore">
            展开
            <i class="el-icon-arrow-down"/>
          </a>
          <a v-else class="actionDown" @click="toggleMore">
            收起
            <i class="el-icon-arrow-up"/>
          </a>
        </span>
        <el-button style="height: 29px" type="primary" @click="searchHandle">查询</el-button>
        <el-button style="height: 29px" type="primary" plain @click="resetHandle">重置</el-button>
      </div>
    </div>
    <!-- 按钮 -->
    <div v-if="toolBarShow" id="toolBar">
      <div class="left">
        <el-button v-if="defaultExpandAll" type="success" plain @click="toggleExpandAll">
          <span v-if="isAllExpanded">
            全部收起 <i class="el-icon-arrow-up"/>
          </span>
          <span v-else>
            全部展开 <i class="el-icon-arrow-down"/>
          </span>
        </el-button>
        <el-button v-if="limits.addAuth" type="primary" @click="$emit('addOrEdit')">新建</el-button>
        <slot name="otherBtn"/>
      </div>
      <div class="right">
        <!-- <div title="导入">
          <i class="el-icon-upload2"/>
        </div> -->
        <div title="设置" @click="openSortDialog">
          <i class="el-icon-setting"/>
        </div>
        <div title="导出" @click="openExportDialog">
          <i class="el-icon-download"/>
        </div>
        <div title="刷新" @click="loadData(1)">
          <i class="el-icon-refresh"/>
        </div>
        <div @click="fullScreen">
          <i v-if="!isFullscreen" title="全屏" class="el-icon-full-screen"/>
          <i v-else title="还原" class="el-icon-aim"/>
        </div>
        <div title="列设置" @click="columnsVisibleOpen">
          <i class="el-icon-menu"/>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <Table
        style="margin-top: 5px"
        :table-select="tableSelect"
        :height="height"
        :loading="loading"
        :border="border"
        :stripe="stripe"
        :columns="columns"
        :data="tableData"
        :span-method="handleSpan"
        :max-height="maxHeight"
        :show-summary="showSummary"
        :summary-method="getSummary"
        @on-selection-change="selectHandle"
        @on-column-width-resize="columnResize"
    >
      <template slot="radio" slot-scope="{ row, index }">
        <el-radio v-model="currentRowIndex" :label="index"/>
      </template>
      <template v-if="tableAction" slot="action" slot-scope="{ row }">
        <el-button
            v-if="limits.editAuth"
            type="primary"
            :disabled="$parent.otherAuth ? $parent.otherAuth(row) : false"
            @click="$emit('addOrEdit', row)"
        >
          编辑
        </el-button
        >
        <slot name="actionBtn" :row="row"/>
        <el-button
            v-if="limits.delAuth"
            :disabled="$parent.otherAuth ? $parent.otherAuth(row) : false"
            type="danger"
            @click="deleteHandle(row)"
        >
          删除
        </el-button
        >
      </template>
    </Table>
    <!-- 分页 -->
    <div v-if="showPage" style="margin-top: 13px; text-align: right">
      <el-pagination
          :current-page="pagination.currentPage"
          :page-sizes="pagination.pageSizeOptions"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
      />
    </div>
    <!-- 列设置 -->
    <el-dialog
        v-if="columnsVisible"
        v-el-drag-dialog
        append-to-body
        title="列设置"
        :visible.sync="columnsVisible"
        width="800px">
      <div id="sortEl">
        <el-checkbox
            v-for="item in allColumns"
            :key="item.name"
            style="margin-bottom: 10px"
            :checked="item.checked"
            :label="item.name"
            @change="checkedChange(item.name)"
        >
          {{item.desc}}
        </el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setColumns()">初始化设置</el-button>
        <el-button type="primary" @click="setColumns(allColumns)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导出 -->
    <el-dialog v-el-drag-dialog title="导出数据" :visible.sync="exportVisible" width="800px">
      <el-form ref="exportForm" :model="model" :rules="rules" label-width="80px">
        <el-form-item label="导出字段" prop="exportFields">
          <el-checkbox-group v-model="model.exportFields">
            <el-checkbox v-for="item in allColumns" :key="item.name" :label="item.name">
              {{item.desc}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportVisible = false">取 消</el-button>
        <el-button type="primary" :loading="exportLoading" @click="sureExport">导 出</el-button>
      </span>
    </el-dialog>
    <!-- 排序设置 -->
    <el-dialog v-el-drag-dialog title="列表设置" :visible.sync="sortVisible" width="800px">
      <div>
        <!-- 表头说明行 -->
        <div class="sort-dialog-header">
          <span class="sort-dialog-item-one">列名</span>
          <span class="sort-dialog-item-two">是否可排序</span>
          <span class="sort-dialog-item-thr">溢出显示...</span>
          <span class="sort-dialog-item-for">冻结</span>
        </div>
        <!-- 配置项 -->
        <div class="sort-dialog-body">
          <div v-for="column in allColumns" :key="column.name">
            <div class="sort-dialog-item">
              <span class="sort-dialog-item-one">{{column.desc}}</span>
              <el-switch
                  v-model="column.sortable"
                  class="sort-dialog-item-two"
                  active-text="开启"
                  inactive-text="关闭"
                  @change="saveSortConfig"/>
              <el-switch
                  v-model="column.tooltip"
                  class="sort-dialog-item-thr"
                  active-text="开启"
                  inactive-text="关闭"
                  @change="saveSortConfig"/>
              <el-radio-group v-model="column.fixed" class="sort-dialog-item-for fixed-radio" @change="saveSortConfig">
                <el-radio label="left">左侧</el-radio>
                <el-radio label="right">右侧</el-radio>
                <el-radio label="">取消</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sortVisible = false">关 闭</el-button>
        <el-button type="primary" @click="setColumns(allColumns)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 排序 -->
  </div>
</template>

<script>
  import Sortable from "sortablejs";
  import commonUtil from "@/util/commonUtil.js";
  export default {
    props: {
      module: {
        type: String,
        required: true,
      },
      method: {
        type: String,
        default: "get",
      },
      columnWidth: {
        type: Number,
        default: null,
      },
      url: {
        type: String,
        required: true,
      },
      // 列属性
      columnsProperty: {
        type: Array,
        default: () => [],
      },
      // 过滤条件
      filter: {
        type: Object,
      },
      // 边框
      border: {
        type: Boolean,
        default: true,
      },
      // 斑马线
      stripe: {
        type: Boolean,
        default: true,
      },
      // 表格高度：如果不设置则计算最大高度，设置则不计算
      height: {
        type: [Number, String],
        default: 0,
      },
      // 表格高度公差：如果计算最大高度，页面中还有其他元素，则可以通过这个功能来处理一下误差
      maxHeightOffset: {
        type: [Number, String],
        default: 0,
      },
      // 可选择
      tableSelect: {
        type: Boolean,
        default: true,
      },
      // 操作栏
      tableAction: {
        type: Boolean,
        default: true,
      },
      // 分页栏
      showPage: {
        type: Boolean,
        default: true,
      },
      // 新增、编辑、删除权限
      limits: {
        type: Object,
        default: () => {
          return {
            addAuth: false,
            editAuth: false,
            delAuth: false,
          };
        },
      },
      // 是否默认展开所有行
      defaultExpandAll: {
        type: Boolean,
        default: false,
      },
      // 工具栏
      toolBarShow: {
        type: Boolean,
        default: true,
      },
      // 合并行的key（树形数据合并，依赖 _groupStart / _groupRowspan）
      spanMergeKeys: {
        type: Array,
        default: null,
      },
      // 一维列表合并列：相邻行值相同时自动合并，值相同就合并
      mergeColumns: {
        type: Array,
        default: () => [],
      },
      // 自定义合并行方法，优先级高于内置合并逻辑
      spanMethod: {
        type: Function,
        default: null,
      },
      // 合计配置
      showSummary: {
        type: Boolean,
        default: false,
      },
      // 需要合计的列
      summaryColumns: {
        type: Array,
        default: () => [],
      },
      // 对应保留小数位数，不配置则默认2位
      summaryToFixed: {
        type: Object,
        default: () => {},
      },
      // 添加合计的相关配置
      summaryProp: {
        type: Object,
        default: () => {
          return {
            auth: {},
          };
        },
      },
      showSearch: {
        type: Boolean,
        default: true,
      },
      // 是否在加载列配置完成后自动查询数据，默认 true；设为 false 时需手动点击查询
      autoLoad: {
        type: Boolean,
        default: true,
      },
      // 数据权限索引，用于控制列的显示
      // 当传入 authIndex 时，会根据 userAuthority 的对应权限位来控制相关列的显示
      authIndex: {
        type: Number,
        default: null,
      },
      // 需要进行权限控制的列关键词列表
      // 当用户的 userAuthority 对应权限位不为 '1' 时，会过滤掉包含这些关键词的列
      authColumnKeywords: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        filterCopy: JSON.stringify(this.filter),
        currentRowIndex: 0,
        columns: [],
        allColumns: [],
        tableData: [],
        loading: false,
        columnsVisible: false,
        pagination: {
          currentPage: 1,
          pageSize: 20,
          pageSizeOptions: [10, 20, 50, 100, 200],
        },
        maxHeight: 0,
        isFullscreen: false,
        exportVisible: false,
        model: {
          exportNum: 100000,
          exportFields: [],
        },
        rules: {
          exportNum: [
            { required: true, message: "请输入导出数量", trigger: "blur" },
            { pattern: /^[1-9]\d*$/, message: "请输入大于0的整数", trigger: "change" },
          ],
          exportFields: [{ type: "array", required: true, message: "请至少选择一个导出字段", trigger: "change" }],
        },
        exportLoading: false,
        selection: [], // 表格选中的数据
        searchShow: false,
        searchs: [],
        // 排序设置
        sortVisible: false,
      };
    },
    computed: {
      isAllExpanded() {
        return this.tableData.every(row => row._expanded);
      },
    },

    mounted() {
      this.getAllColumns();
      let node = this.$el.querySelector("#searchBox");
      this.searchs = node.getElementsByClassName("el-form-item");
      for (let i = 0; i < this.searchs.length; i++) {
        if (i > 5) {
          this.searchs[i].style.display = "none";
        }
      }
      this.tableHeight();
      // 窗口缩放 重新计算表格的最大高度
      window.onresize = () => {
        this.tableHeight();
      };
    },

    methods: {
      handleSpan({ row, column, rowIndex }) {
        // 优先 prop，降级到 $attrs（兼容热更新缓存问题）
        const mergeCols = this.mergeColumns || this.$attrs["merge-columns"] || this.$attrs.mergeColumns || [];
        // 一维列表数据合并：相邻行值相同时自动合并
        if (mergeCols && mergeCols.length > 0) {
          const colKey = column.key;
          if (colKey && mergeCols.includes(colKey)) {
            const data = this.tableData;
            const currentVal = row[colKey];
            // 向上查找相同值的起始行
            let startIndex = rowIndex;
            while (startIndex > 0 && data[startIndex - 1] && data[startIndex - 1][colKey] === currentVal) {
              startIndex--;
            }
            // 非起始行隐藏
            if (rowIndex !== startIndex) {
              return [0, 0];
            }
            // 向下统计连续相同值的行数
            let rowspan = 1;
            for (let i = rowIndex + 1; i < data.length; i++) {
              if (data[i] && data[i][colKey] === currentVal) {
                rowspan++;
              } else {
                break;
              }
            }
            return [rowspan, 1];
          }
          return [1, 1];
        }
        // 内置合并逻辑：当数据来自树结构（父有 children）时，扁平化行上有 _groupStart / _groupRowspan
        if (this.spanMergeKeys) {
          const colKey = column.key;
          if (!colKey) return;
          if (!this.spanMergeKeys.includes(colKey)) {
            return [1, 1];
          }
          if (row && row._groupStart) {
            const span = row._groupRowspan && row._groupRowspan > 0 ? row._groupRowspan : 1;
            return [span, 1];
          }
          return [0, 0];
        }
      },

      // 将后端/模拟的树形数据转换为表格需要的扁平数组，并在首条明细上标注合并信息
      // 同时将父级的所有属性合并到每个子行，便于列显示与导出
      flattenTree(list) {
        if (!Array.isArray(list)) return [];
        const flat = [];
        for (const group of list) {
          const children = Array.isArray(group.details) && group.details.length > 0 ? group.details : [Object.assign({}, group)];
          const rowspan = children.length || 1;
          for (let i = 0; i < children.length; i++) {
            const childRaw = children[i] || {};
            // 合并父级属性到子行，子级同名字段优先保留（child overrides parent）
            // 但 pkId 应始终以父级为准；如果子级有 pkId，则备份到 itemId
            const parentPk = group && group.pkId !== undefined ? group.pkId : undefined;
            const childPk = childRaw && childRaw.pkId !== undefined ? childRaw.pkId : undefined;
            // 先合并（child 覆盖 parent），随后强制使用 parent 的 pkId
            const merged = Object.assign({}, group, childRaw);
            if(group && group.pkid !== undefined) {
              merged.pkid = group.pkid;
            }
            // 移除嵌套的 details，避免递归污染
            if (merged.details) delete merged.details;

            // 备份子级 pkId 为 itemId（若存在）或保留原有 itemId
            if (childPk !== undefined) {
              merged.itemId = childPk;
            } else if (merged.itemId === undefined && childRaw.itemId !== undefined) {
              merged.itemId = childRaw.itemId;
            }
            // 强制把 pkId 设为父级的 pkId（如果父级存在）
            if (parentPk !== undefined) {
              merged.pkId = parentPk;
            }

            // 标注分组信息，仅在组首行设置 _groupStart 和 _groupRowspan
            if (i === 0) {
              merged._groupStart = true;
              merged._groupRowspan = rowspan;
            } else {
              merged._groupStart = false;
              merged._groupRowspan = 0;
            }

            // 保存组的总行数到每个条目，方便列渲染时判断组大小
            merged._groupTotal = rowspan;
            flat.push(merged);
          }
        }
        return flat;
      },
      getAllColumns() {
        this.loading = true;
        // 获取所有可用列
        let func; 
        let params = Object.assign({ pageSize: this.pagination.pageSize, pageNum: 1 }, this.filter);
        if(this.method === "get") {
          func = this.$http.get("basic", `${this.url}`, params, { "All-Fields": 1 });
        } else {
          func = this.$http[this.method]("basic", `${this.url}`, params, { "All-Fields": 1 });
        }
        func.then((res) => {
          if (res.success) {
            this.columns = [];
            this.allColumns = res.data;

            // 数据权限控制：过滤 allColumns
            this.allColumns = this.filterColumnsByAuth(this.allColumns);

            // 获取用户配置列
            this.$http.get("basic", `userHabits?code=${this.url}`).then((resp) => {
              if (resp.data && resp.data.description) {
                let userColumns = JSON.parse(resp.data.description);
                userColumns.forEach((item, i) => {
                  let index = this.allColumns.findIndex((i) => i.name === item.name);
                  if (index === -1) {
                    userColumns.splice(i, 1);
                  } else {
                    item.desc = this.allColumns[index].desc;
                  }
                });
                this.allColumns = userColumns;
                this.allColumns.forEach((item) => {
                  if (item.checked) {
                    this.columns.push({ 
                      title: item.desc, 
                      key: item.name, 
                      resizable: true, 
                      minWidth: 100, 
                      width: item.width || this.columnWidth,
                      sortable: item.sortable,
                      tooltip: item.tooltip,
                      fixed: item.fixed,
                    });
                  }
                });
              } else {
                // 没有设置过列
                this.allColumns.forEach((item) => {
                  this.columns.push({ title: item.desc, key: item.name, resizable: true, minWidth: 100, width: "" });
                  item.checked = true;
                });
              }

              // 数据权限控制：过滤 columns
              this.columns = this.filterColumnsByAuth(this.columns);

              this.columnsProperty.forEach((item) => {
                let findIndex = this.columns.findIndex((i) => item.key === i.key);
                if (findIndex !== -1) {
                  let temp = { ...this.columns[findIndex], ...item };
                  if (this.columns[findIndex].width) {
                    temp.width = this.columns[findIndex].width;
                  }
                  // this.columns[findIndex] = temp;
                  this.$set(this.columns, findIndex, temp);
                } else if (item.key === "action") {
                  item.title = "操作";
                  item.key="action";
                  this.columns.push(item);
                } else if (item.key === "radio") {
                  // console.log(item)
                  item.key="radio";
                  this.columns.unshift(item);
                } else if (item.type === "expand") {
                  item.key="expand";
                  this.columns.unshift(item);
                } else if (item.type === "index") {
                  item.key="index";
                  this.columns.unshift(item);
                }
              });
              // table可选择
              if (this.tableSelect) {
                this.columns.unshift({ type: "selection",key: "selection", width: 54, align: "center", fixed: "left" });
              }
              // 列配置加载完成后，默认自动查询；autoLoad=false 时不自动查询，需用户手动点击查询
              if (this.autoLoad) {
                this.loadData(1);
              }
            });
          }
        });
      },

      // 根据权限过滤列
      // 该方法会检查 authIndex，如果用户没有权限，则过滤掉包含 authColumnKeywords 关键词的列
      filterColumnsByAuth(columns) {
        // 判断是否需要进行权限控制
        const needAuthControl = this.authIndex !== null && this.authIndex !== undefined;

        if (!needAuthControl) {
          return columns;
        }

        // 使用 $auth 方法检查权限（该方法在 myPlugin.js 中定义）
        const hasAuth = this.$auth(this.authIndex);

        if (hasAuth) {
          return columns;
        }

        // 如果没有权限，过滤掉相关的列
        // 根据列的显示名称（desc 或 title）来判断是否为需要控制的列
        return columns.filter(item => {
          const displayName = item.desc || item.title || "";
          // 过滤掉包含 authColumnKeywords 中关键词的列
          return !this.authColumnKeywords.some(keyword => displayName.includes(keyword));
        });
      },

      // 获取数据
      loadData(pageNum) {
        let that = this;
        if (pageNum) {
          that.pagination.currentPage = pageNum;
        }
        that.loading = true;
        let params = Object.assign({ pageSize: that.pagination.pageSize, pageNum: that.pagination.currentPage }, that.filter);
        that.$http[this.method](`${that.module}`, `${that.url}`, params)
          .then((res) => {
            if (res.success) {
              // 如果后端返回的是树结构（每条记录包含 details），则扁平化后赋值
              const records = res.data.records;
              // 如果 records 是树形数据（包含 details），flattenTree 会处理；否则直接赋值
              if (Array.isArray(records) && records.some((r) => Array.isArray(r.details)) && this.spanMergeKeys) {
                that.tableData = that.flattenTree(records);
              } else {
                that.tableData = records;
              }
              that.pagination.total = res.data.total;
              
              // 如果需要默认展开所有行，将所有行的pkId添加到expandRowKeys数组中
              if (that.defaultExpandAll) {
                that.$nextTick(() => {
                  that.tableData = that.tableData.map(row => {
                    row._expanded = true;
                    return row;
                  });
                });
              }
            }
            that.loading = false;
            that.$emit("data-loaded", that.tableData);
          })
          .catch(() => {
            that.loading = false;
          });
      },
      toggleExpandAll() {
        this.tableData = this.tableData.map(row => {
          row._expanded = !row._expanded;
          return row;
        });
        return this.tableData.some(row => row._expanded);
      },
      // 列设置模态框
      columnsVisibleOpen() {
        this.columnsVisible = true;
        this.$nextTick(() => {
          this.sortColumns();
        });
      },

      checkedChange(name) {
        this.allColumns.forEach((item) => {
          if (item.name === name) {
            item.checked = !item.checked;
          }
        });
      },

      // 列排序
      sortColumns() {
        const that = this;
        const el = document.getElementById("sortEl");
        const options = {
          animation: 150,
          onEnd: function(evt) {
            that.allColumns.splice(evt.newIndex, 0, that.allColumns.splice(evt.oldIndex, 1)[0]);
            const newArr = that.allColumns.slice(0);
            that.allColumns = [];
            that.$nextTick(function() {
              that.allColumns = newArr;
            });
          },
        };
        Sortable.create(el, options);
      },

      // 设置列显示
      setColumns(string) {
        const params = {
          code: this.url,
          description: string ? JSON.stringify(string) : "",
        };
        this.$http.post("basic", "userHabits", params).then((res) => {
          if (res.success) {
            this.$message.success("设置成功");
            this.columnsVisible = false;
            this.sortVisible = false;
            this.getAllColumns();
          }
        });
      },

      // 拖拽调整列宽
      columnResize() {
        this.columns.forEach((item) => {
          this.allColumns.forEach((i) => {
            if (item.key === i.name) {
              if (item.width) {
                i.width = parseInt(item.width);
              }
            }
          });
        });
        const params = {
          code: this.url,
          description: JSON.stringify(this.allColumns),
        };
        this.$http
          .post("basic", "userHabits", params)
          .then(() => {})
          .catch(() => {});
      },

      // 切换分页
      handleCurrentChange(page) {
        this.pagination.currentPage = page;
        this.loadData();
      },

      // 切换分页条数
      handleSizeChange(pageSize) {
        this.pagination.pageSize = pageSize;
        this.loadData();
      },

      // 设置表格最大高度
      tableHeight() {
        if (!this.height) {
          const clientHeight = document.body.clientHeight;
          let searchBoxHeight = document.getElementById("searchBox") ? document.getElementById("searchBox").offsetHeight : 0;
          if (searchBoxHeight < 60) {
            searchBoxHeight = 56;
          }
          const toolbarHeight = document.getElementById("toolBar") ? document.getElementById("toolBar").offsetHeight : 0;
          this.maxHeight = clientHeight - toolbarHeight - searchBoxHeight - 148 - this.maxHeightOffset;
        }
      },

      // 点击查询：先查询数据，并通知父组件（用于联动刷新等）
      searchHandle() {
        this.loadData(1);
        this.$emit("search");
      },

      // 重置
      resetHandle() {
        this.$emit("reset", JSON.parse(this.filterCopy));
        this.$nextTick(() => {
          this.loadData(1);
        });
      },

      // 全屏/还原
      fullScreen() {
        let fullscreenEnabled =
          document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled;
        if (fullscreenEnabled) {
          let element = document.getElementsByClassName("vm-main-page")[0];
          if (this.isFullscreen) {
            // 关闭全屏
            if (element.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
              document.webkitCancelFullScreen();
            }
          } else {
            if (element.requestFullscreen) {
              element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
              element.mozRequestFullScreen();
            } else if (element.webkitRequestFullScreen) {
              element.webkitRequestFullScreen();
            }
          }
          this.isFullscreen = !this.isFullscreen;
        }
      },

      // 打开导出模态框
      openExportDialog() {
        this.exportVisible = true;
        this.model.exportFields = [];
        this.allColumns.forEach((item) => {
          if (item.checked) {
            this.model.exportFields.push(item.name);
          }
        });
      },
      // 打开排序设置模态框
      openSortDialog() {
        // 从localStorage加载排序配置
        this.sortVisible = true;
      },
      // 保存排序配置到localStorage
      saveSortConfig() {
        // 过滤出需要保存的列配置
        const sortableColumns = this.columns
          .filter(col => !["action", "radio", "expand", "index"].includes(col.key) && col.type !== "selection")
          .map(col => ({ key: col.key, sortable: col.sortable, tooltip: col.tooltip, fixed: col.fixed }));
        
        // 获取现有的配置
        let columnsSortableProperty = {};
        const stored = localStorage.getItem("columnsPropertySettings");
        if (stored) {
          columnsSortableProperty = JSON.parse(stored);
        }
        // 更新配置
        columnsSortableProperty[this.url] = sortableColumns;
        localStorage.setItem("columnsPropertySettings", JSON.stringify(columnsSortableProperty));
      },
   
      // 导出
      sureExport() {
        this.$refs.exportForm.validate((valid) => {
          if (valid) {
            this.exportLoading = true;
            let params = Object.assign({
              pageNum: 1,
              pageSize: this.model.exportNum,
            }, this.filter);
            const fun = this.method === "postJson" ? "exportExcelPost" : "exportExcel";
            this.$http[fun]("basic", `${this.url}`, params, this.model.exportFields.join(), this.method === "postJson" ? "post" : this.method)
              .then((res) => {
                // 确保响应数据是arraybuffer类型
                if (!res.data || !(res.data instanceof ArrayBuffer)) {
                  this.$message.error("下载失败：响应数据格式不正确");
                  return;
                }
                
                // 创建Blob时指定正确的MIME类型
                const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const downloadElement = document.createElement("a");
                const href = window.URL.createObjectURL(blob);
                
                // 解析文件名，增加容错处理
                let fileName = "export";
                const contentDisposition = res.headers["content-disposition"] || res.headers["Content-Disposition"];
                if (contentDisposition) {
                  fileName = decodeURI(contentDisposition.split("filename*=utf-8''")[1]).split(".")[0];
                }
                
                // 确保文件名以.xlsx结尾
                if (!fileName.toLowerCase().endsWith(".xlsx")) {
                  fileName = fileName + ".xlsx";
                }
                
                downloadElement.style.display = "none";
                downloadElement.href = href;
                downloadElement.download = fileName;
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
                
                this.exportVisible = false;
                this.exportLoading = false;
              })
              .catch((error) => {
                console.error("下载失败:", error);
                this.$message.error("下载失败：" + (error.message || "未知错误"));
                this.exportVisible = false;
              }).finally(() => {
                this.exportLoading = false;
              });
          }
        });
      },

      // 表格数据选中时触发
      selectHandle(selection) {
        // console.log(selection);
        this.$emit("select", selection);
      },

      // 删除
      deleteHandle(row) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" })
          .then(() => {
            this.$emit("delete", row);
          })
          .catch(() => {});
      },

      // 展开与收起
      toggleMore() {
        this.searchShow = !this.searchShow;
        for (let i = 0; i < this.searchs.length; i++) {
          if (i > 5) {
            if (this.searchShow) {
              this.searchs[i].style.display = "inline-block";
            } else {
              this.searchs[i].style.display = "none";
            }
          }
        }
        this.$nextTick(() => {
          this.tableHeight();
        });
      },

      // 单击一行
      rowClick(row, index) {
        this.currentRowIndex = index;
      },

      // 合计方法
      getSummary({ columns, data }) {
        const sums = {};
        columns.forEach((column, index) => {
          const key = column.key;
          if (index === 0) {
            sums[key] = {
              key,
              value: "合计",
            };
            return;
          }
          if (this.summaryColumns.includes(key)) {
            const values = data.map(item => Number(item[key]));
            const v = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            let fixedNumber;
            if (this.summaryToFixed) {
              fixedNumber = this.summaryToFixed[key] || 2;
            } else {
              fixedNumber = 2;
            }
            if(this.summaryProp.auth[key] || this.summaryProp.auth[key] === undefined) {
              sums[key] = {
                key,
                value: commonUtil.formatNumber(v.toFixed(fixedNumber)),
              };  
            } else {
              sums[key] = {
                key,
                value: "***",
              };
            }
          } else {
            sums[key] = {
              key,
              value: "",
            };
          }
        });
        return sums;
      },
    },
  };
</script>

<style lang="scss">
.viewTable {
  #searchBox {
    display: flex;
    background-color: #f4f7fa;
    padding: 15px 10px 10px 10px;
    border: 1px solid #e8e8e8;
    border-radius: 3px;
    margin-bottom: 5px;
    .el-form-item {
      margin-bottom: 5px;
    }
    .moreSearch {
      min-width: 200px;
      line-height: 29px;
      .actionDown {
        font-weight: bolder;
        margin-right: 5px;
      }
    }
    .el-input__inner {
      width: 180px;
    }
    .el-date-editor {
      width: 435px;
    }
  }
  #toolBar {
    height: 28px;
    display: flex;
    .left {
      flex: 1;
    }
    .right {
      width: 300px;
      display: flex;
      justify-content: flex-end;
      div {
        width: 30px;
        height: 28px;
        border-radius: 15px;
        border: 1px solid #e8e8e8;
        line-height: 28px;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
        margin-left: 10px;
        &:hover {
          color: #2d8cf0;
        }
      }
    }
  }
  .ivu-table td,
  .ivu-table th {
    height: 37px;
    font-size: 13px;
    .el-button--mini {
      padding: 7px 10px;
    }
  }
  .ivu-table thead tr th{
    padding: 7.5px 0;
  }
  #sortEl {
    .el-checkbox {
      cursor: move;
    }
  }
  .el-radio__label {
    padding-left: 0;
    display: none;
  }
  .fixed-radio{
    .el-radio{
      margin-right: 5px;
    }
    .el-radio__label{
      display: initial;
      padding-left:5px;
    }
  }
  .ivu-table-cell-with-expand {
    height: 37px;
    line-height: 37px;
  }
  .ivu-table-summary{
    .ivu-table-cell{
      padding-left: 5px;
      padding-right: 5px;
    }
  }
}
.sort-dialog-header{
  display: flex; 
  justify-content: space-between; 
  align-items: center; 
  margin-bottom: 5px; 
  font-weight: bold; 
  padding-bottom: 5px; 
  border-bottom: 1px solid #e8e8e8;
}
.sort-dialog-body{
  max-height: 600px; overflow-y: auto;
}
.sort-dialog-item{
  display: flex; justify-content: space-between; align-items: center; padding: 5px 0; border-bottom: 1px solid #e8e8e8;
}
.sort-dialog-item-one{
  width: 140px;
}
.sort-dialog-item-two{
  width: 120px;
  text-align: center;
}
.sort-dialog-item-thr{
  width: 120px;
  text-align: center;
}
.sort-dialog-item-for{
  width: 160px;
  text-align: center;
}
</style>